import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const CouponIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 512 512">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill="currentColor" stroke="currentColor" strokeWidth="200">
            <path d="M220 4143 c-98 -34 -170 -107 -204 -206 -14 -41 -16 -110 -16 -517
l0 -470 27 -30 c24 -26 39 -33 96 -41 96 -13 158 -43 212 -100 66 -70 88 -127
88 -219 0 -92 -22 -149 -88 -219 -54 -58 -120 -89 -212 -100 -57 -7 -70 -12
-95 -40 l-29 -32 3 -487 3 -487 25 -50 c31 -64 91 -124 155 -155 l50 -25 532
-3 c472 -2 536 -1 564 13 34 18 59 67 59 115 0 96 107 190 218 190 95 0 202
-100 202 -190 0 -48 25 -97 59 -114 27 -15 179 -16 1523 -14 l1493 3 50 25
c64 31 124 91 155 155 l25 50 3 487 3 487 -29 32 c-25 28 -38 33 -95 40 -92
11 -158 42 -212 100 -66 70 -88 127 -88 219 0 92 22 149 88 219 54 58 120 89
212 100 57 7 70 12 95 40 l29 32 -3 487 -3 487 -36 65 c-23 42 -52 78 -83 101
-97 74 19 69 -1623 69 -1634 0 -1519 5 -1549 -65 -8 -19 -14 -48 -14 -65 0
-90 -107 -190 -202 -190 -112 0 -217 94 -218 193 0 45 -26 95 -59 111 -26 14
-97 16 -548 16 -444 -1 -524 -3 -563 -17z m994 -266 c43 -91 119 -165 213
-210 63 -30 76 -32 173 -32 97 0 110 2 173 32 94 45 170 119 213 210 l35 73
1396 0 c1546 0 1444 4 1477 -65 14 -28 16 -88 16 -418 l0 -385 -32 -6 c-149
-28 -314 -182 -370 -344 -33 -95 -33 -249 0 -344 56 -162 221 -316 370 -344
l32 -6 0 -385 c0 -330 -2 -390 -16 -418 -33 -69 70 -65 -1483 -65 -1164 0
-1401 2 -1401 13 0 8 -14 41 -30 74 -39 77 -121 155 -207 196 -63 30 -76 32
-173 32 -97 0 -110 -2 -173 -32 -94 -45 -170 -119 -213 -210 l-35 -73 -436 0
c-484 0 -487 0 -517 65 -14 28 -16 88 -16 418 l0 385 33 6 c148 28 313 182
369 344 33 95 33 249 0 344 -56 162 -221 316 -369 344 l-33 6 0 385 c0 329 2
390 16 418 30 64 31 65 516 65 l437 0 35 -73z"/>
            <path d="M2566 3510 c-116 -30 -234 -130 -289 -247 -29 -62 -32 -77 -32 -163
0 -66 6 -111 18 -147 28 -79 98 -167 169 -214 87 -55 151 -72 259 -67 76 4 97
9 162 41 143 71 228 199 235 358 5 106 -12 171 -67 256 -45 70 -125 135 -203
165 -61 23 -192 32 -252 18z m211 -236 c116 -67 135 -233 37 -330 -68 -69
-154 -82 -243 -38 -132 66 -157 229 -51 334 73 74 167 86 257 34z"/>
            <path d="M1538 3390 c-43 -33 -50 -67 -46 -210 l3 -132 33 -29 c38 -34 93 -39
131 -13 39 28 51 73 51 194 0 121 -12 166 -51 194 -32 22 -91 20 -121 -4z"/>
            <path d="M3123 2637 l-773 -772 0 -48 c0 -66 39 -107 99 -107 37 0 49 7 129
79 48 44 399 391 780 773 l692 694 0 48 c0 39 -5 53 -29 77 -24 24 -38 29 -78
29 l-48 0 -772 -773z"/>
            <path d="M1542 2754 c-43 -30 -52 -65 -52 -194 0 -129 9 -164 52 -194 29 -21
87 -20 117 0 39 28 51 73 51 194 0 121 -12 166 -51 194 -30 20 -88 21 -117 0z"/>
            <path d="M3605 2432 c-120 -41 -205 -117 -258 -230 -39 -83 -49 -206 -23 -293
23 -83 86 -171 156 -223 85 -62 144 -81 261 -81 90 0 99 2 170 37 94 46 168
122 212 215 29 62 32 77 32 163 0 116 -19 175 -81 260 -50 69 -139 132 -218
155 -67 20 -189 19 -251 -3z m224 -218 c132 -66 157 -229 51 -334 -105 -106
-268 -81 -334 51 -43 88 -30 176 39 244 68 69 156 83 244 39z"/>
            <path d="M1528 2101 l-33 -29 0 -152 0 -152 33 -29 c38 -34 93 -39 131 -13 39
28 51 73 51 194 0 121 -12 166 -51 194 -38 26 -93 21 -131 -13z"/>
        </g>
    </SvgIcon>
);

export default CouponIcon;